'use strict';

function KYCPartnerDown() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_Paths];

  this.history = new History();

  this.init = function () {
    this.analytics.pushEvent('virtual-page-view');

    // Set guard from hitting the end point twice. kyc_decision to kyc_partner_down status from KYCQuestions
    if (this.presenter.hasAction('account.create_kyc_questions') && this.presenter.models.account.kyc_decision !== 'kyc_partner_down') {
      this.presenter.performAction('account.create_kyc_questions', { device_print: '' }, this._onCheckEndpoint.bind(this));
    }

    // This page also used for credit-check endpoint
    if (this.presenter.hasAction('account.get_credit_detail') && this.presenter.models.account.kyc_decision !== 'credit_check_partner_down') {
      this.presenter.performAction('account.get_credit_detail', this._onCheckEndpoint.bind(this));
    }
  };

  this.initAllReady = function () {};

  this._onCheckEndpoint = function (data, response) {
    // Equifax Timeout check
    if (response !== 503 && !data.errors) {
      this.history.goToUrl(this.paths.account.dashboard); // will reroute if needed
    }
  };

  this.destroy = function () {};
}